import { FeatureFlag } from '../FeatureFlag';

export const enableGlobalAssistant = new FeatureFlag({
    key: 'enable-global-assistant',
    defaultValue: false,
});
